class textFormatter {
  onlyLetters(key) {
    let char = String.fromCharCode(key.keyCode); // Get the character
    if(/^[A-Za-z]+$/.test(char)) return true; // Match with regex

    if (
      // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
      /^(8|9|13|46|37|39|17|32)$/.test(key.keyCode) ||
      // permite ctrl+ c,v,x,a,z
      /^(67|86|88|65|90)$/.test(key.keyCode) && key.ctrlKey
    ) return;
    key.preventDefault();
    key.stopPropagation();
  }

  onlyNumbers(key) {

    if (
      // permite somente numeros
      (key.keyCode >= 48 && key.keyCode <= 57) || (key.keyCode >= 96 && key.keyCode <= 105) ||
      // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
      /^(8|9|13|46|37|39|17)$/.test(key.keyCode) ||
      // permite ctrl+ c,v,x,a,z
      /^(67|86|88|65|90)$/.test(key.keyCode) && key.ctrlKey
    ) return;
    key.preventDefault();
    key.stopPropagation();        
  
  }

}

export default new textFormatter();